// Stimulus controller for User Onboarding Goals form to handle button logic changes
import { Controller } from '@hotwired/stimulus';

export default class GoalFormController extends Controller<HTMLFormElement> {
  static targets = ['checkbox', 'submit', 'skip'];

  declare checkboxTargets: HTMLInputElement[];
  declare submitTarget: HTMLButtonElement;
  declare skipTarget: HTMLButtonElement;

  connect(): void {
    this.updateSubmitButtonState()
    this.updateSkipButtonState()
  }

  handleClick(): void {
    this.updateSubmitButtonState()
    this.updateSkipButtonState()
  }

  // Enable/disable 'Not listed' button
  updateSkipButtonState(): void {
    const anyChecked = this.checkboxTargets.some(checkbox => checkbox.checked);

    this.skipTarget.disabled = anyChecked
    this.skipTarget.classList.toggle('onboarding__skip-button--disabled', anyChecked)
  }

  // Enable/disable 'Next' button
  updateSubmitButtonState(): void {
    const anyChecked = this.checkboxTargets.some(checkbox => checkbox.checked);

    this.submitTarget.disabled = !anyChecked;
    this.submitTarget.classList.toggle('onboarding__submit-button--disabled', !anyChecked);
  }
}
